"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Text = require("../../Text");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: ", ";\n  font-size: 1.2rem;\n  color: ", ";\n  margin-bottom: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.3rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Element = _styledComponents.default.span(_templateObject(), function (props) {
  return props.display;
}, _Constant.Color.ERROR, function (props) {
  return props.display === 'block' ? '1.6rem' : 'auto';
}, _Constant.Width.MD);

var Error = function Error(_ref) {
  var children = _ref.children,
      display = _ref.display,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "display"]);
  return children ? /*#__PURE__*/_react.default.createElement(Element, (0, _extends2.default)({}, props, {
    display: display
  }), display !== 'block' && /*#__PURE__*/_react.default.createElement(_Text.Asterisk, null), children) : null;
};

Error.propTypes = {
  /** The value for the css display property */
  display: _propTypes.default.string,

  /** The string that should be rendered */
  children: _propTypes.default.string.isRequired,

  /** Applied to the base element */
  className: _propTypes.default.string
};
Error.defaultProps = {
  display: 'inline',
  className: 'error'
};
var _default = Error;
exports.default = _default;